(function () {
  document.querySelectorAll('[data-product-info-tabs]').forEach(function (tabs) {
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-tab-button]'));
    if (!buttons.length) return;

    function activate(button) {
      buttons.forEach(function (btn) {
        var isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');

        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = !isActive;
      });
    }

    buttons.forEach(function (button, index) {
      button.setAttribute('tabindex', index === 0 ? '0' : '-1');
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

      button.addEventListener('click', function () {
        activate(button);
      });

      button.addEventListener('keydown', function (event) {
        var currentIndex = buttons.indexOf(button);
        var newIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          newIndex = (currentIndex + 1) % buttons.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          newIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        } else if (event.key === 'Home') {
          newIndex = 0;
        } else if (event.key === 'End') {
          newIndex = buttons.length - 1;
        }

        if (newIndex !== null) {
          event.preventDefault();
          buttons[newIndex].focus();
          activate(buttons[newIndex]);
        }
      });
    });

    activate(buttons[0]);
  });
})();
